import React, { useEffect, useState } from 'react';
import blogimage1 from '../assets/images/blogimage1.jpg';
import blogimage2 from '../assets/images/blogimage2.jpg';
import blogimage3 from '../assets/images/blogimage3.jpg';
import blogimage4 from '../assets/images/blogimage4.jpg';
import blogimage5 from '../assets/images/blogimage5.jpg';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import config from "../../src/config"
import axios from 'axios';
export default function HomeMediaSection({ customClass }) {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        async function fetchBlogs() {
            try {
                const response = await axios.get(`${config.BASE_URL}/api/admin/get-medias`, { withCredentials: true });
                setBlogs(response.data);
            } catch (error) {
                console.error("Error fetching blogs:", error);
            }
        }
        fetchBlogs();
    }, []);
    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 800,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 0,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
             {
                breakpoint: 1290, // tablet / small laptop
                settings: {
                    slidesToShow: 4,
                    centerMode: false,
                },
            },
             {
                breakpoint: 1024, // tablet / small laptop
                settings: {
                    slidesToShow: 3,
                    centerMode: false,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ]
    };
    const sliderSettings2 = {
        dots: false,
        infinite: true,
        speed: 800,
        arrows: false,
        slidesToShow: 3, // ✅ desktop default
        slidesToScroll: 1,
        initialSlide: 0,
        centerMode: true, // ✅ important fix for clean desktop layout
        autoplay: true,
        autoplaySpeed: 3000,

        responsive: [
            {
                breakpoint: 1024, // tablet / small laptop
                settings: {
                    slidesToShow: 2,
                    centerMode: false,
                },
            },
            {
                breakpoint: 767, // mobile large
                settings: {
                    slidesToShow: 2,
                    centerMode: false,
                },
            },
            {
                breakpoint: 480, // mobile small
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                },
            },
        ],
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);

        const options = { month: 'long', year: 'numeric' };
        const monthYear = date.toLocaleDateString(undefined, options);

        const day = date.getDate();
        const suffix = (day) => {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        };

        return `${monthYear.split(' ')[0]} ${day}${suffix(day)}, ${monthYear.split(' ')[1]}`;
    };


    return (
        <>
            <div className={`home-recent-blog-- home-recent-media d-flex bg-white position-relative ${customClass}`} data-aos="fade-up" data-aos-delay="2000" data-aos-duration="1000">
                <div className='width-25'>

                    <h6 className='font-11 text-uppercase position-absolute-- font-medium'>JOURNAL</h6>
                    <h2 className='text-black font-thin home-heading-media-width'>the Ivey journal and media archive</h2>

                </div>
                {blogs.slice(0, 1).map(blog => (
                    <div className='home-recent-blog-items home-media-itemsleft home-recent-project-item'>
                        <div className='blog-featured-image'>
                            {/* <img src={`${config.BASE_URL}${blog?.mediafile}`} alt={blog.title} /> */}
                            {blog?.mediafile?.match(/\.(mp4|webm|ogg)$/i) ? (
                                <video
                                    src={`${config.BASE_URL}${blog.mediafile}`}
                                    controls={false} autoPlay
                                    muted
                                    loop
                                    playsInline
                                    ref={(video) => {
                                        if (video) {
                                            video.playbackRate = 0.5; // slow speed (0.5x)
                                        }
                                    }}
                                    style={{ width: "100%" }}
                                />
                            ) : (
                                <img
                                    src={`${config.BASE_URL}${blog.mediafile}`}
                                    alt={blog.title}
                                    style={{ width: "100%" }}
                                />
                            )}
                        </div>
                        <h2 className='font-thin font-media-homepage-1'> <Link to={blog?.link} target="_blank" rel="noopener noreferrer"
                            className='text-black'>
                            {blog.title}
                        </Link></h2>

                        <div className='home-media-view-more recent-project-detail d-flex'>
                            <span className='project-scale font-10-view-more-media text-black'><Link to={blog?.link} target="_blank" rel="noopener noreferrer"
                                className='text-black'>VIEW MORE</Link></span>
                        </div>
                    </div>
                ))}

                <div className='home-ecent-blog-items home-ecent-blog-itemsright-- home-media-itemsright'>
                    {blogs.slice(1, 2).map(blog => (
                        <div className='home-recent-blog-items-inner home-recent-project-item '>
                            <div className='blog-featured-image aspct-rtio-244-344'>
                                {/* <img src={`${config.BASE_URL}${blog?.mediafile}`} alt={blog.title} /> */}
                                {blog?.mediafile?.match(/\.(mp4|webm|ogg)$/i) ? (
                                    <video
                                        src={`${config.BASE_URL}${blog.mediafile}`}
                                        controls={false} autoPlay
                                        muted
                                        loop
                                        playsInline
                                        ref={(video) => {
                                            if (video) {
                                                video.playbackRate = 0.5; // slow speed (0.5x)
                                            }
                                        }}
                                        style={{ width: "100%" }}
                                    />
                                ) : (
                                    <img
                                        src={`${config.BASE_URL}${blog.mediafile}`}
                                        alt={blog.title}
                                        style={{ width: "100%" }}
                                    />
                                )}
                            </div>
                            <h2 className='font-thin font-media-homepage-2'> <Link to={blog?.link} target="_blank" rel="noopener noreferrer"
                                className='text-black'>
                                {blog.title}
                            </Link></h2>
                            <div className='home-media-view-more recent-project-detail d-flex'>
                                <span className='project-scale font-10-view-more-media text-black'><Link to={blog?.link} target="_blank" rel="noopener noreferrer"
                                    className='text-black'>VIEW MORE</Link></span>
                            </div>
                        </div>
                    ))}

                    {blogs.slice(2, 3).map(blog => (
                        <div className='home-recent-blog-items-inner home-recent-project-item '>
                            <div className='blog-featured-image aspct-rtio-244-344'>
                                {/* <img src={`${config.BASE_URL}${blog?.mediafile}`} alt={blog.title} /> */}

                                {blog?.mediafile?.match(/\.(mp4|webm|ogg)$/i) ? (
                                    <video
                                        src={`${config.BASE_URL}${blog.mediafile}`}
                                        controls={false} autoPlay
                                        muted
                                        loop
                                        playsInline
                                        ref={(video) => {
                                            if (video) {
                                                video.playbackRate = 0.5; // slow speed (0.5x)
                                            }
                                        }}
                                        style={{ width: "100%" }}
                                    />
                                ) : (
                                    <img
                                        src={`${config.BASE_URL}${blog.mediafile}`}
                                        alt={blog.title}
                                        style={{ width: "100%" }}
                                    />
                                )}
                            </div>

                            <h2 className='font-thin font-media-homepage-2'> <Link to={blog?.link} target="_blank" rel="noopener noreferrer"
                                className='text-black'>
                                {blog.title}
                            </Link></h2>
                            <div className='home-media-view-more recent-project-detail d-flex'>
                                <span className='project-scale font-10-view-more-media text-black'><Link to={blog?.link} target="_blank" rel="noopener noreferrer"
                                    className='text-black'>VIEW MORE</Link></span>
                            </div>
                        </div>
                    ))}
                </div>
                <div className='home-ecent-blog-items home-ecent-blog-itemsright- desktop-only-slider'>
                    <Slider {...sliderSettings}>
                        {blogs.slice(3, 8).map(blog => (

                            <div className='home-recent-blog-items-inner home-recent-project-item d-flex flex-row pr-10'>
                                <div className='blog-featured-image aspct-rtio-244-344-  '>
                                    {blog?.mediafile?.match(/\.(mp4|webm|ogg)$/i) ? (
                                        <video
                                            src={`${config.BASE_URL}${blog.mediafile}`}
                                            controls={false} autoPlay
                                            muted
                                            loop
                                            playsInline
                                            ref={(video) => {
                                                if (video) {
                                                    video.playbackRate = 0.5;
                                                }
                                            }}
                                            style={{ width: "100%" }}
                                        />
                                    ) : (
                                        <img
                                            src={`${config.BASE_URL}${blog.mediafile}`}
                                            alt={blog.title}
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </div>

                                <h2 className='font-thin font-media-homepage-2'> <Link to={blog?.link} target="_blank" rel="noopener noreferrer"
                                    className='text-black'>
                                    {blog.title}
                                </Link></h2>
                                <div className='home-media-view-more recent-project-detail d-flex'>
                                    <span className='project-scale font-10-view-more-media text-black'><Link to={blog?.link} target="_blank" rel="noopener noreferrer"
                                        className='text-black'>VIEW MORE</Link></span>
                                </div>
                            </div>
                        ))}
                    </Slider>
                    {/* {blogs.slice(4, 5).map(blog => (

                        <div className='home-recent-blog-items-inner home-recent-project-item '>
                            <div className='blog-featured-image aspct-rtio-244-344-'>
                                

                                {blog?.mediafile?.match(/\.(mp4|webm|ogg)$/i) ? (
                                    <video
                                        src={`${config.BASE_URL}${blog.mediafile}`}
                                        controls={false} autoPlay
                                        muted
                                        loop
                                        playsInline
                                        ref={(video) => {
                                            if (video) {
                                                video.playbackRate = 0.5; // slow speed (0.5x)
                                            }
                                        }}
                                        style={{ width: "100%" }}
                                    />
                                ) : (
                                    <img
                                        src={`${config.BASE_URL}${blog.mediafile}`}
                                        alt={blog.title}
                                        style={{ width: "100%" }}
                                    />
                                )}
                            </div>

                            <h2 className='font-thin font-media-homepage-2'> <Link to={blog?.link} target="_blank" rel="noopener noreferrer"
                                className='text-black'>
                                {blog.title}
                            </Link></h2>
                            <div className='home-media-view-more recent-project-detail d-flex'>
                                <span className='project-scale font-10-view-more-media text-black'><Link to={blog?.link} target="_blank" rel="noopener noreferrer"
                                    className='text-black'>VIEW MORE</Link></span>
                            </div>


                        </div>
                    ))} */}

                </div>
            </div>
            <div className='home-recent-projet-slider bg-white home-blog-slider'>




                <Slider {...sliderSettings}>
                    {blogs.slice(0, 3).map((blog) => (
                        <div
                            key={blog.id}
                            className="home-recent-blog-items-inner home-recent-project-item"
                        >
                            <div className="blog-featured-image aspct-rtio-244-344">
                                {/* <img src={`${config.BASE_URL}${blog?.mediafile}`} alt={blog.title} /> */}

                                {blog?.mediafile?.match(/\.(mp4|webm|ogg)$/i) ? (
                                    <video
                                        src={`${config.BASE_URL}${blog.mediafile}`}
                                        controls={false} autoPlay
                                        muted
                                        loop
                                        playsInline
                                        ref={(video) => {
                                            if (video) {
                                                video.playbackRate = 0.5; // slow speed (0.5x)
                                            }
                                        }}
                                        style={{ width: "100%" }}
                                    />
                                ) : (
                                    <img
                                        src={`${config.BASE_URL}${blog.mediafile}`}
                                        alt={blog.title}
                                        style={{ width: "100%" }}
                                    />
                                )}
                            </div>

                            <h2 className="font-thin font-media-homepage-2">
                                <Link to={blog?.link} target="_blank" rel="noopener noreferrer" className="text-black">
                                    {blog.title}
                                </Link>
                            </h2>

                            <div className="home-media-view-more recent-project-detail d-flex">
                                <span className="project-scale font-10-view-more-media text-black">
                                    <Link to={blog?.link} target="_blank" rel="noopener noreferrer"
                                        className='text-black'>VIEW MORE</Link>
                                </span>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>



        </>
    )
}
